<!--
 * @Author: qhy
 * @Date: 2023-03-28 22:26:02
 * @LastEditors: qhy
 * @LastEditTime: 2023-07-08 16:32:16
 * @Description:
-->
<template>
  <div>
    <div class="footer">
      <div class="text">
       吉林一号 © 2023-2026 长光卫星技术股份有限公司 版权所有 |
        <span @click="goPrivacyPolicy()" style="cursor: pointer">隐私协议</span>
        |
        <span @click="goServiceAgreement()" style="cursor: pointer"
          >服务条款</span
        >
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
export default {
  name: "HomeFooter1",
  data() {
    return {};
  },
  methods: {
    goJl1mall() {
      window.open("http://jl1mall.com", "_self"); //打开一个新的标签页
    },
    goPrivacyPolicy() {
      window.open("http://jl1mall.com/PrivacyPolicy", "_self");
    },
    goServiceAgreement() {
      window.open("http://jl1mall.com/ServiceAgreement", "_self");
    },
  },

  mounted() {
    let b_top=$('.footer').offset().top;
    let window_height=$(window).height();
    if(window_height-b_top>120){
      $('.footer').addClass('fixedBottom')
    }
    console.log(window_height-b_top)
  },
};
</script>

<style scoped>
.footer {
  position: relative;
  width: 100%;
  height: 120px;
  background-color: #ffffff;
  z-index: 10000;
}
.fixedBottom{
  position: fixed;
  bottom:0px;
}
.text {
  position: absolute;
  top: 50px;
  left: calc(50% - 350px);
  width: 700px;
  height: 17px;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #3a3a3a;
  line-height: 17px;
  text-align: center;
}
</style>
